module.exports = __webpack_public_path__ + "static/img/Whitehead-Breiana.2cda37f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Whitehead-Breiana.jpg
// module id = 7qK8
// module chunks = 1